// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1XXbD","inner":"Form_inner__320Ws","range":"Form_range__3kYbp","name":"Form_name__1FLXS","actions":"Form_actions__2b_cs"};